export const SITE_URL = "https://racketly.pro";
export const SITE_NAME = "Racketly";
export const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;
export const DEFAULT_IMAGE_ALT = "Racketly score tracking on iPhone and Apple Watch";

// Paths are explicit: campaign parameters and fragments never enter canonicals.
export function canonicalUrl(path = "/") {
	const pathname = path.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
	return new URL(pathname, `${SITE_URL}/`).href;
}

export function absoluteAssetUrl(image) {
	return new URL(image, `${SITE_URL}/`).href;
}

export const pageMetadata = {
	home: {
		path: "/",
		title: "Apple Watch Score Tracker for Tennis & Padel | Racketly",
		description: "Track tennis, padel, pickleball and badminton scores on your Apple Watch with Racketly. Save match history and review your progress on iPhone or Android.",
	},
	blog: {
		path: "/blog",
		title: "Tennis & Padel Tips, Scoring Rules and Guides | Racketly",
		description: "Explore tennis and padel scoring rules, match strategy, racket sport news and Racketly guides. Learn how to keep score and review your next match.",
	},
	download: {
		path: "/download",
		title: "Download Racketly for iPhone, Apple Watch & Android",
		description: "Download Racketly to track tennis, padel, pickleball and badminton matches. Get the iPhone and Apple Watch app on the App Store, or Android on Google Play.",
	},
	privacy: {
		path: "/privacy",
		title: "Privacy Policy | Racketly",
		description: "Read Racketly's Privacy Policy to learn how the app collects, uses, shares and protects your information, and how to exercise your data rights.",
	},
	terms: {
		path: "/terms",
		title: "Terms and Conditions | Racketly",
		description: "Read the Terms and Conditions for using Racketly, including subscriptions, analysis credits, AI-powered insights and user responsibilities.",
	},
	notFound: {
		path: "/404",
		title: "Page Not Found | Racketly",
		description: "This Racketly page could not be found. Visit the homepage, browse tennis and padel guides, or download the score tracking app.",
		noindex: true,
	},
};

export function postMetadata(post) {
	return {
		path: `/blog/${post.slug}`,
		title: post.seoTitle || `${post.title} | Racketly`,
		description: post.seoDescription || post.excerpt,
		image: post.image,
		imageAlt: post.imageAlt,
		imageWidth: post.imageWidth,
		imageHeight: post.imageHeight,
		type: "article",
		publishedTime: post.date,
		modifiedTime: post.updatedAt,
		section: post.category,
	};
}
